<!-- FullPageLoader.vue -->
<template>
    <div v-if="visible" class="loader-overlay">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
  </template>
  
  <script setup>
  import { inject } from 'vue'
  const visible = inject('loading')
  </script>
  
  <style scoped>
  .loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  </style>
  